import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useSearchParams } from "react-router-dom";
import dayjs from "dayjs";

import { Text } from "../../shared/uiComponents";
import { HeaderWrapper } from "./helpers";

import Assessment from "./Assessment";
import TreatmentPlanning from "./TreatmentPlanning";
import BehaviorTreatment from "./BehaviorTreatment";
import DirectSupervision from "./DirectSupervision";
import BehaviorTreatmentModification from "./BehaviorTreatmentModification";
import ParentTraining from "./ParentTraining";
import MeetAndGreet from "./MeetAndGreet";

import { DispatchProperties, useSelector } from "../../redux/store";
import { getSessionInfo } from "../../redux/State/clientSlice/sessionSlice";
import { clearDrafts } from "../../redux/State/clientSlice/soapNoteSlice";

const SOAPNote = () => {
  const dispatch = useDispatch<DispatchProperties>();
  const [params] = useSearchParams();

  const { sessionType, client, date } = useSelector((state) => state.session.sessionInfo);
  const supervisor = useSelector((state) => state.soapNote.soapNoteData.supervisor);

  useEffect(() => {
    const sessionId = params.get("sessionId");
    if (!sessionId) return;

    dispatch(getSessionInfo(sessionId));
  }, [params, dispatch]);

  useEffect(() => {
    return () => {
      dispatch(clearDrafts());
    };
  }, [dispatch]);

  return (
    <div className="container" style={{ flexDirection: "column", maxWidth: "900px" }}>
      <HeaderWrapper className="title marginBottom16">
        <Text title="SOAP Note" size="mediumBold" />
        {!!date && <Text title={`Date: ${dayjs(date).format("MM/DD/YYYY")}`} size="mediumBold" />}
        {!!client?.fullName && <Text title={client.fullName} size="smallBold" />}
        {!!supervisor?.id && <Text title={`Supervisor: ${supervisor.fullName}`} size="smallBold" />}
      </HeaderWrapper>
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <Text title={"Service: "} size={"mediumBold"} />
        <Text title={sessionType.name} size="medium" />
      </div>
      <div className="marginBottom16" />
      {findSoapNoteTamplate(sessionType.type)}
    </div>
  );
};

export const findSoapNoteTamplate = (type: number) => {
  switch (type) {
    case 1:
      return <Assessment />;
    case 2:
      return <TreatmentPlanning />;
    case 3:
      return <BehaviorTreatment />;
    case 4:
      return <DirectSupervision />;
    case 5:
      return <BehaviorTreatmentModification />;
    case 6:
      return <ParentTraining />;
    case 7:
      return <MeetAndGreet />;
    case 8:
      return <MeetAndGreet />;
    default:
      return null;
  }
};

export default SOAPNote;
